import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Product,
  ProductImage,
  ProductName,
  ProductAlcohol,
  ProductNet,
  ProductFooter,
  ProductPrice,
  ProductQuantityWrapper,
  ProductCart,
  ProductQuantity,
  ProductQuantityBox,
  FavoriteIconWrapper,
  InputQuantity
} from "./styles";
import HideImageIcon from "@mui/icons-material/HideImage";
import { privateAPI } from '../../../utils/api';
import { getCookie } from '../../../utils/cookie';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const SingleProduct = ({ ...props }) => {
  const navigate = useNavigate();
  const [isLoggedIn] = useState(getCookie('token'));
  let [productQuantity, setProductQuantity] = useState(1);
  const { t, i18n } = useTranslation();
  const [isInFavorite, setIsInFavorite] = useState(false);
  const [favorite, setFavorite] = useState([]);
  const [userID] = useState(getCookie('userId'));
  var language = i18n.language;

  const setProductInCart = async () => {
    const response = await privateAPI.get(`/auth/bacchus/client/cart/${userID}`);
    const isProductInCart = response.data.cartProducts.some(item => item.id === props.item.id)

    if(isProductInCart) return toast.warning('Product is already in cart');

    try{
        const id = getCookie('userId');
        const productDTO = {
            productId: props.item.id,
            quantity: productQuantity,
            userId: id
        }
        await privateAPI.post(`/auth/bacchus/client/cart`, productDTO);
        toast.success('In cart!')
    } catch (error){
        if(error.request && error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const redirecting = (product) => {
    const path = window.location.pathname;
    if(path.includes("product")){
      props.setSingleProduct(product)
      window.scrollTo(0, 100);
    } else {
      navigate(`/group/${product.productGroupId}/product/${product.id}`);
      window.scrollTo(0, 0);
    }
  }

  const getUserFavorites = async () => {
    if(isLoggedIn){
      try {
        const favoriteResponse = await privateAPI.get(`/auth/bacchus/client/user/favourite/${userID}`);

        setFavorite(favoriteResponse.data)
        setIsInFavorite(favoriteResponse.data.some(item => item.productFavId === props.item.id))
      } catch (error) {
        console.error(error)
      }
    }
  };

  const setInFavorite = async (productId) => {
    const favouriteDTO = {
      productFavId: productId,
      userFavId: userID
    }

    try {
      if(isInFavorite) {
        const favoriteId = favorite.find(item => item.productFavId === productId);
        if(favoriteId){
          await privateAPI.delete(`/auth/bacchus/client/user/favourite/${favoriteId.id}`);
          if(props.favorite){
            props.getUserFavorites();
          }
        }
      } else {
        await privateAPI.post(`/auth/bacchus/client/user/favourite`, favouriteDTO);
      }
      getUserFavorites();
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getUserFavorites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Product favorite={props.favorite}>
      {isLoggedIn ? 
          <FavoriteIconWrapper>
            {isInFavorite ? 
              <FavoriteIcon style={{ color: '#1b2c58', cursor: 'pointer' }} onClick={() => setInFavorite(props.item.id)}/>
              :
              <FavoriteBorderIcon style={{ color: '#1b2c58', cursor: 'pointer' }} onClick={() => setInFavorite(props.item.id)}/>  
            }
          </FavoriteIconWrapper>
          :
          <></>
      }
      {props.item.image ? 
        <ProductImage
          src={props.item.image[0]}
          alt={props.item.name}
          onClick={() => redirecting(props.item)}
          />
       : 
       <HideImageIcon
          style={{ height: "50px", width: "50px", color: "#001753 !important" }}
          onClick={() => redirecting(props.item)}
          />
      }
      <ProductName
        onClick={() => redirecting(props.item)}
        carousel={props.carousel ?? false }
        >
        {language === "en"
          ? props.item.name
          : language === "fr"
          ? props.item.name_fr
          : language === "de"
          ? props.item.name_de
          : language === "it"
          ? props.item.name_it
          : props.item.name}
      </ProductName>
      <ProductAlcohol
        onClick={() => redirecting(props.item)}
        >
        {props.item.alcoholPercentage ? (
          `${t('alcohol')}: ${props.item.alcoholPercentage}% vol`
        ) : (
          <>&nbsp;</>
        )}
      </ProductAlcohol>
      <ProductNet
        onClick={() => redirecting(props.item)}
        >
        {t('net')}: {props.item.liter}l
      </ProductNet>
      <ProductFooter>
        <ProductPrice>{props.item.price.toFixed(2)} CHF</ProductPrice>
        <ProductQuantityWrapper>
          <ProductQuantity>{t('quantity')}: </ProductQuantity>
          <ProductQuantityBox>
            <button
              style={{ border: "none", background: "none", width: "15px" }}
              onClick={() =>
                productQuantity && setProductQuantity(--productQuantity)
              }
              disabled={productQuantity === 0}
            >
              -
            </button>
            <InputQuantity
              type="number"
              min={0}
              max={props.item.stock}
              value={productQuantity}
              onChange={(e) => setProductQuantity(e.target.value)}
              style={{ maxWidth: "30px" }}
              />
            <button
              style={{ border: "none", background: "none", width: "15px" }}
              onClick={() => setProductQuantity(++productQuantity)}
              disabled={productQuantity >= props.item.stock}
              >
              +
            </button>
          </ProductQuantityBox>
        </ProductQuantityWrapper>
        <ProductCart onClick={productQuantity <= props.item.stock ? () => setProductInCart() : () => toast.info('Over stock')}/>
      </ProductFooter>
    </Product>
  );
};

export default SingleProduct;
